const user = localStorage.getItem("noqEventUser") || sessionStorage.getItem("noqEventUser");
const userObj = JSON.parse(user);
const token = userObj?.token;

const getEvents = async (organizerId, userToken, page = 1) => {
    try {
        const rawData = await fetch(
            `${process.env.REACT_APP_API_BASE_URL}/organizers/${organizerId}/events?inc_organizer=true&page=${page}`,

            {
                method: "GET",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${userToken || token}`,
                    "X-Client-Token": process.env.REACT_APP_CLIENT_TOKEN,
                },
            }
        );
        const res = await rawData.json();

        return res;
    } catch (error) {
        console.log("error", error);
    }
};

const getOrganizers = async (userToken) => {
    try {
        const rawData = await fetch(
            `${process.env.REACT_APP_API_BASE_URL}/organizers`,

            {
                method: "GET",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${userToken || token}`,
                    "X-Client-Token": process.env.REACT_APP_CLIENT_TOKEN,
                },
            }
        );
        const res = await rawData.json();

        return res;
    } catch (error) {
        console.log("error", error);
    }
};

const getSingleEvent = async (eventId) => {
    try {
        const rawData = await fetch(
            `${process.env.REACT_APP_API_BASE_URL}/events/${eventId}?inc_organizer=true`,

            {
                method: "GET",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                    "X-Client-Token": process.env.REACT_APP_CLIENT_TOKEN,
                },
            }
        );
        const res = await rawData.json();

        return res;
    } catch (error) {
        console.log("error", error);
    }
};

const getEventVendors = async (eventId, page) => {
    try {
        const rawData = await fetch(
            `${process.env.REACT_APP_API_BASE_URL}/events/${eventId}/vendors?page=${page}`,

            {
                method: "GET",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                    "X-Client-Token": process.env.REACT_APP_CLIENT_TOKEN,
                },
            }
        );
        const res = await rawData.json();

        return res;
    } catch (error) {
        console.log("error", error);
    }
};

const createEvent = async (organizerId, data, token) => {
    try {
        const rawData = await fetch(
            `${process.env.REACT_APP_API_BASE_URL}/organizers/${organizerId}/events`,
            {
                method: "POST",
                // FormData so the logo file is sent as multipart; the browser sets the Content-Type boundary
                headers: {
                    Authorization: `Bearer ${token}`,
                    Accept: "application/json",
                    "X-Client-Token": process.env.REACT_APP_CLIENT_TOKEN,
                },
                body: data,
            }
        );
        const res = await rawData.json();

        return res;
    } catch (error) {
        console.log("error", error);
    }
};

const updateEvent = async (eventId, data, token) => {
    try {
        const rawData = await fetch(`${process.env.REACT_APP_API_BASE_URL}/events/${eventId}`, {
            method: "POST",
            headers: {
                Authorization: `Bearer ${token}`,
                // Accept: "application/json",
                // "Content-Type": "application/json",
                "X-Client-Token": process.env.REACT_APP_CLIENT_TOKEN,
            },
            body: data,
        });
        const res = await rawData.json();

        return res;
    } catch (error) {
        console.log("error", error);
    }
};

const publishEvent = async (eventId, token) => {
    try {
        const rawData = await fetch(
            `${process.env.REACT_APP_API_BASE_URL}/events/${eventId}/publish`,
            {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${token}`,
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    "X-Client-Token": process.env.REACT_APP_CLIENT_TOKEN,
                },
            }
        );
        const res = await rawData.json();

        return res;
    } catch (error) {
        console.log("error", error);
    }
};

const unpublishEvent = async (eventId, token) => {
    try {
        const rawData = await fetch(
            `${process.env.REACT_APP_API_BASE_URL}/events/${eventId}/unpublish`,
            {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${token}`,
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    "X-Client-Token": process.env.REACT_APP_CLIENT_TOKEN,
                },
            }
        );
        const res = await rawData.json();

        return res;
    } catch (error) {
        console.log("error", error);
    }
};

export const eventManagerServices = {
    getEvents,
    getOrganizers,
    getSingleEvent,
    getEventVendors,
    createEvent,
    updateEvent,
    publishEvent,
    unpublishEvent,
};
